// extracted by mini-css-extract-plugin
export default {"page":"surprisePage_page__1zsNC"};